// extracted by mini-css-extract-plugin
export default {"paginationContainer":"_3ClOz"};